var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disclaimer"},[_c('h3',{staticClass:"heading"},[_vm._v("Important")]),_c('ul',[_c('li',[_vm._v(_vm._s(_vm.$t('disclaimer.leadTime')))]),_c('li',[_vm._v(_vm._s(_vm.$t('disclaimer.manufacturing')))]),_c('li',[_vm._v(_vm._s(_vm.$t('disclaimer.email')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }